import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { MagnifyingGlass, DownloadSimple } from '@phosphor-icons/react';
import { LEAD_STATUSES, STABILITY_LEVELS } from '@/lib/constants';

const STABILITY_OPTIONS = [STABILITY_LEVELS.HIGH, STABILITY_LEVELS.MODERATE, STABILITY_LEVELS.LOW];

const FilterControls = ({
  search, setSearch, filterStability, setFilterStability,
  filterStatus, setFilterStatus, onSearch, onExport,
}) => (
  <div className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm mb-6">
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Input
        placeholder="Search by organization or name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && onSearch()}
        data-testid="admin-search-input"
      />
      <Select value={filterStability} onValueChange={setFilterStability}>
        <SelectTrigger><SelectValue placeholder="Filter by stability" /></SelectTrigger>
        <SelectContent>
          <SelectItem value=" ">All Stability Levels</SelectItem>
          {STABILITY_OPTIONS.map(level => (
            <SelectItem key={level} value={level}>{level}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={filterStatus} onValueChange={setFilterStatus}>
        <SelectTrigger><SelectValue placeholder="Filter by status" /></SelectTrigger>
        <SelectContent>
          <SelectItem value=" ">All Statuses</SelectItem>
          {LEAD_STATUSES.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
        </SelectContent>
      </Select>
      <div className="flex gap-2">
        <Button
          onClick={onSearch}
          className="flex-1 bg-slate-900 text-white hover:bg-slate-800"
          data-testid="admin-search-button"
        >
          <MagnifyingGlass size={20} weight="bold" className="mr-2" />
          Search
        </Button>
        <Button onClick={onExport} variant="outline" data-testid="export-csv-button">
          <DownloadSimple size={20} weight="bold" />
        </Button>
      </div>
    </div>
  </div>
);

export default FilterControls;
